import React from "react";
import { useForm, Controller } from "react-hook-form";
import { loginProvider } from "_services/oauth";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import { makeStyles } from "@material-ui/core/styles";
import styles from "assets/jss/material-dashboard-react/views/loginPageStyle.js";

const useStyles = makeStyles(styles);


const ProviderID = (props) => {

    const { location, ...other } = props;
    const history = useHistory();
    const queryString = decodeURIComponent(window.location.search);
    const params = new URLSearchParams(queryString);
    const code = params.get('code');
    const url = 'https://moph.id.th';

    const [mophData, setMophData] = React.useState(null);

    React.useEffect(() => {

        loginProvider({ username: code })
            .then((token) => {

                if (token.data.success) {

                    if (location.state != null && location.state.redirect != null && location.state.redirect != '')
                        history.push(location.state.redirect);
                    else
                        history.push("/home");
                } else {
                    history.push("/auth/login-page?error=ไม่พบ Provider ID ในระบบ");
                }


            })
            .catch((error) => {
                history.push("/auth/login-page?error=ไม่สามารถใช้งานได้");
            });

    },[]);

    const classes = useStyles();


    return (
        <div>
        </div>
    );
}
export default ProviderID;